import {
    ChangeDetectorRef,
    Component, ElementRef, HostListener, Inject, Input, Renderer2, ViewChild

} from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
// import { environmentsActions } from '@src/store/reducers/environmentsReducer';
// import { projectsActions } from '@src/store/reducers/projectsReducer';
import {DialogManagerService } from '@src/services';
import { Store } from '@src/store';
import { MatSort } from '@angular/material/sort';
import moment from 'moment';



export interface IDeployedPackagesTable {
    CDate: string;
    ServerMachineName: string;
    ObjOwner: string;
    ObjName: string;
    ObjType: string;
    OpretionType:any,
    CurrentUser: string;
    CurrentOSUser: string;
    MachineName: string;
    IsSchemaLocke:any;
    CheckedOutUser:any;
    IntegrationState:boolean;
    IntegrationUser:string;
    IsAllowed:boolean;
    script:string
}

@Component({
    selector: 'reports-audit-data',
    template: require('./reports-audit-data.component.html'),
    styles: [require('./reports-audit-data.component.scss')]
})
export class ReportDataAuditComponent {
    public projectId: any;
    public dplModeType: any;
    public environmentId: string;
    private envDetail: any;
    private renderComp: boolean;
/*    public page = 1;*/
/*    @Output() public getRecords = new EventEmitter();*/
    @Input() public isHistory: boolean = false;
    public get data() {
        return this._data;
    }

    @Input() public set data(value) {
        if (value) {
            this._data = value;
            const data = [];
            value.forEach((item) => {
                item.tagsNames = item.tags ? item.tags.map(m => m.displayName).join(', ') : '';
                data.push({
                    CDate : this.convertUTCtoLocal(item.CDate), 
                    ServerMachineName : item.ServerMachineName,
                    ObjOwner:item.ObjOwner ,
                    ObjName : item.ObjName,
                    ObjType: item.ObjType,
                    OpretionType: item.EventType ,
                    CurrentUser: item.CurrentUser,
                    CurrentOSUser: item.CurrentOSUser,
                    MachineName: item.MachineName,
                    CurrentProgram: item.CurrentProgram,
                    IsSchemaLocked: item.IsSchemaLocked === -1 ?  'Not Managed': item.IsSchemaLocked,
                    CheckedOutUser: item.CheckedOutUser,
                    IntegrationState: item.IntegrationState,
                    IntegrationUser : item.IntegrationUser,
                    IsAllowed : item.IsAllowed,
                    script : item.SQLText,
                    packageId: item.VersionId,
                    projectId: item.FlowId,
                    scriptId: item.ScriptId
                });
            });
            this.dataSource.data = data;
        }
    }
    // tslint:disable-next-line:variable-name
    private _data: any;

    //public displayedColumns = ['CDate', 'ServerMachineName', 'ObjOwner', 'ObjName', 'ObjType', 'OpretionType', 'CurrentUser', 'CurrentOSUser', 'MachineName', 'CurrentProgram', 'IsSchemaLocked', 'CheckedOutUser', 'IntegrationState' , 'IntegrationUser','IsAllowed' ,'script'];
    public displayedColumns = ['CDate', 'ServerMachineName', 'ObjOwner', 'ObjName', 'ObjType', 'CurrentUser', 'CurrentOSUser', 'MachineName' ,'script'];
    public dataSource = new MatTableDataSource<IDeployedPackagesTable>([]);
    @ViewChild(MatSort) public sort: MatSort;

    private pressed = false;
  //  private currentResizeIndex: number;
    private startX: number;
    private startWidth: number;
    private isResizingRight: boolean;
    private resizableMousemove: () => void;
    private resizableMouseup: () => void;

    @ViewChild(MatTable, { read: ElementRef }) private matTableRef: ElementRef;
    private columns: any[] = [
        { field: 'CDate', width: 100 },
        { field: 'ServerMachineName', width: 300 },
        { field: 'ObjOwner', width: 350 },
        { field: 'ObjName', width: 230 },
        { field: 'ObjType', width: 150 },
        //{ field: 'OpretionType', width: 150 },
        { field: 'CurrentUser', width: 150 },
        { field: 'CurrentOSUser', width: 50 },
        //{ field: 'MachineName', width: 150 },
        //{ field: 'CurrentProgram', width: 150 },
        //{ field: 'IsSchemaLocked', width: 100 },
        //{ field: 'CheckedOutUser', width: 100 },
        //{ field: 'IntegrationState', width: 100 },
        //{ field: 'IntegrationUser', width: 50 },
        //{ field: 'IsAllowed', width: 50 },
        { field: 'script', width: 20 }
    ];

    constructor(
        private store: Store,
        @Inject('$stateParams') stateParams: any,
        private renderer: Renderer2,
        private cdr: ChangeDetectorRef,
        private dialogManagerService: DialogManagerService 

    ) {
        this.projectId = stateParams.id;
        this.environmentId = stateParams.envID;

    }

    convertUTCtoLocal(date) {
        if (!date)
            return;
        var stillUtc = moment.utc(date).toDate();
        var local = moment(stillUtc).local().toDate();
        return local.toLocaleString();
    }


/*    scroll(event: any) {
        if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
            this.page += 1
            this.getRecords.emit(this.page)
        }
    }*/


    showScript(entity) {
        if (!entity.scriptId) {
            this.dialogManagerService.showScriptViewerDialog({
                dispatch: (action) => this.store.dispatch(action),
                script: entity.script,
                projectId: "",
                packageId: "",
                scriptId: ""
            });
        } else {
            this.dialogManagerService.showScriptViewerDialog({
                dispatch: (action) => this.store.dispatch(action),
                script: entity.script,
                packageId: entity.packageId,
                projectId: entity.projectId,
                scriptId: entity.scriptId
            });
        }
    }

    ngOnChanges() {
        if (this.renderComp) {
            this.cdr.detectChanges();
        }
    }

    public ngOnInit() {
   //   this.dataSource.sort = this.sort;
    }

    public ngAfterViewInit() {
        //this.setTableResize(this.matTableRef.nativeElement.clientWidth);
    }


    public isActionColumnVisible(): boolean {
        if (!(this.envDetail && this.envDetail.environments)) {
            return false;
        }
        const environment = this.envDetail.environments.find(m => m.id.toString() === this.environmentId);
        if (!environment) {
            return false;
        }
        return !this.isHistory && this.dplModeType === 'ByTask' && !environment.isManaged && !environment.isRMSource;
    }

    /*
        private setTableResize(tableWidth: number) {
        let totWidth = 0;
        this.columns.forEach((column) => {
            totWidth += column.width;
        });
        const scale = (tableWidth - 5) / totWidth;
        this.columns.forEach((column) => {
            column.width *= scale;
            this.setColumnWidth(column);
        });
    }
        */

    public onResizeColumn(event: any, index: number) {
        this.checkResizing(event, index);
      //  this.currentResizeIndex = index;
        this.pressed = true;
        this.startX = event.pageX;
        this.startWidth = event.target.clientWidth;
        event.preventDefault();
        this.mouseMove(index);
    }




    private checkResizing(event, index) {
        const cellData = this.getCellData(index);
        if ((index === 0) ||
            (Math.abs(event.pageX - cellData.right) < cellData.width / 2 && index !== this.columns.length - 1)) {
            this.isResizingRight = true;
        } else {
            this.isResizingRight = false;
        }
    }

    private getCellData(index: number) {
        const headerRow = this.matTableRef.nativeElement.children[0];
        const cell = headerRow.children[0].children[index];
        return cell.getBoundingClientRect();
    }

    private mouseMove(index: number) {
        this.resizableMousemove = this.renderer.listen('document', 'mousemove', (event) => {
            if (this.pressed && event.buttons) {
                const dx = (this.isResizingRight) ? (event.pageX - this.startX) : (-event.pageX + this.startX);
                const width = this.startWidth + dx;
                // if (this.currentResizeIndex === index && width > 50) {
                    this.setColumnWidthChanges(index, width);
                // }
            }
        });
        this.resizableMouseup = this.renderer.listen('document', 'mouseup', () => {
            if (this.pressed) {
                this.pressed = false;
                // this.currentResizeIndex = -1;
                this.resizableMousemove();
                this.resizableMouseup();
            }
        });
    }

    private setColumnWidthChanges(index: number, width: number) {
        const orgWidth = this.columns[index].width;
        const dx = width - orgWidth;
        if (dx !== 0) {
            const j = (this.isResizingRight) ? index + 1 : index - 1;
            const newWidth = this.columns[j].width - dx;
            if (newWidth > 50) {
                this.columns[index].width = width;
                this.setColumnWidth(this.columns[index]);
                this.columns[j].width = newWidth;
                this.setColumnWidth(this.columns[j]);
            }
        }
    }

    private setColumnWidth(column: any) {
        const columnEls = Array.from(document.getElementsByClassName(`mat-column-${column.field}`));
        columnEls.forEach((el: HTMLDivElement) => {
            const packageNameElement = Array.from(el.getElementsByClassName('dp-package-name'));
            if (packageNameElement && packageNameElement.length > 0) {
                const el1: HTMLElement = packageNameElement[0] as HTMLElement;
                el1.style.width = `${column.width}px`;
            }
            el.style.width = `${column.width}px`;
        });
    }

    @HostListener('window:resize', ['$event'])
    public onResize() {
        //this.setTableResize(this.matTableRef.nativeElement.clientWidth);
    }

    public getTagsName(tags: any): string {
        return tags.map(t => t.displayName).join(',');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/reports/report-details-an7/reports-audit-data/reports-audit-data.component.ts